// extracted by mini-css-extract-plugin
module.exports = {"loginHeader":"LoginHeader_loginHeader__2SyMr","loginTitle":"LoginHeader_loginTitle__2hjl3"};